import { render, staticRenderFns } from "./SelectSchool.vue?vue&type=template&id=5f9e3e5c&"
import script from "./SelectSchool.vue?vue&type=script&lang=js&"
export * from "./SelectSchool.vue?vue&type=script&lang=js&"
import style0 from "./SelectSchool.vue?vue&type=style&index=0&id=5f9e3e5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports